function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.56 6.56l1.73 1.73c.391.391.393 1.027.002 1.418L9.708 21.292a1.007 1.007 0 01-1.418-.002l-1.73-1.73A1.5 1.5 0 004.44 17.44l-1.73-1.73a1.004 1.004 0 010-1.417L14.291 2.708a1.006 1.006 0 011.418.002l1.73 1.73A1.5 1.5 0 0019.56 6.56zm-6.766.146l-6.088 6.088c-.39.39-.382 1.03-.003 1.41l3.094 3.093c.388.388 1.025.38 1.409-.003l6.088-6.088c.39-.39.382-1.03.003-1.41l-3.094-3.093a1.002 1.002 0 00-1.409.003zM16.5 10.5l-6 6-3-3 6-6 3 3z",
    fill: "#292A2B"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-ticket.svg";